import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';
const _c0 = ["ng-doc-button-icon", ""];
const _c1 = ["*"];
let NgDocButtonIconComponent = /*#__PURE__*/(() => {
  class NgDocButtonIconComponent {
    constructor() {
      this.size = 'medium';
      this.rounded = true;
    }
    static {
      this.ɵfac = function NgDocButtonIconComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocButtonIconComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocButtonIconComponent,
        selectors: [["button", "ng-doc-button-icon", ""], ["a", "ng-doc-button-icon", ""], ["button", "ng-doc-button-icon-raised", ""], ["a", "ng-doc-button-icon-raised", ""], ["button", "ng-doc-button-icon-transparent", ""], ["a", "ng-doc-button-icon-transparent", ""]],
        hostVars: 2,
        hostBindings: function NgDocButtonIconComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("data-ng-doc-size", ctx.size)("data-ng-doc-rounded", ctx.rounded);
          }
        },
        inputs: {
          size: "size",
          rounded: "rounded"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        attrs: _c0,
        ngContentSelectors: _c1,
        decls: 1,
        vars: 0,
        template: function NgDocButtonIconComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        styles: ["[_nghost-%COMP%]{position:relative;display:inline-flex;align-items:center;justify-content:center;border:0;cursor:pointer;border-radius:50%;border:var(--ng-doc-button-border);width:calc(var(--ng-doc-base-gutter) * 4);height:calc(var(--ng-doc-base-gutter) * 4);background-color:var(--ng-doc-button-background);color:var(--ng-doc-button-color);overflow:hidden;--ng-doc-icon-color: var(--ng-doc-button-color)}[data-ng-doc-size=small][_nghost-%COMP%]{width:calc(var(--ng-doc-base-gutter) * 3);height:calc(var(--ng-doc-base-gutter) * 3)}[data-ng-doc-size=large][_nghost-%COMP%]{width:calc(var(--ng-doc-base-gutter) * 5);height:calc(var(--ng-doc-base-gutter) * 5)}[_nghost-%COMP%]:hover{background-color:var(--ng-doc-button-hover-background);color:var(--ng-doc-button-hover-color);border:var(--ng-doc-button-hover-border);--ng-doc-icon-color: var(--ng-doc-button-hover-color)}[_nghost-%COMP%]:active{background-color:var(--ng-doc-button-active-background);color:var(--ng-doc-button-active-color);border:var(--ng-doc-button-active-border);--ng-doc-icon-color: var(--ng-doc-button-active-color)}[data-ng-doc-rounded=false][_nghost-%COMP%]{border-radius:var(--ng-doc-base-gutter)}[ng-doc-button-icon-transparent][_nghost-%COMP%]{--ng-doc-button-color: var(--ng-doc-base-6);--ng-doc-button-hover-color: var(--ng-doc-base-8);--ng-doc-button-active-color: var(--ng-doc-base-10);--ng-doc-button-hover-background: transparent;--ng-doc-button-active-background: transparent}[ng-doc-button-icon-raised][_nghost-%COMP%]{--ng-doc-button-background: var(--ng-doc-base-1);--ng-doc-button-border: 1px solid var(--ng-doc-base-3);--ng-doc-button-hover-background: var(--ng-doc-base-2);--ng-doc-button-hover-border: 1px solid var(--ng-doc-base-4);--ng-doc-button-active-background: var(--ng-doc-base-3);--ng-doc-button-active-border: 1px solid var(--ng-doc-base-5)}"],
        changeDetection: 0
      });
    }
  }
  return NgDocButtonIconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocButtonIconComponent };
